import { useEffect, useState } from "react";
import { Button, Modal, Text } from "@simplybusiness/mobius";
import { DynamicContent } from "./DynamicContent/DynamicContent";
import type { InterventionProps, Site, Vertical } from "../../types";

type CoverageDiagnosisProps = {
  initialShow: boolean;
  vertical: Vertical;
} & InterventionProps;

export const CoverageDiagnosis = (props: CoverageDiagnosisProps) => {
  const { vertical, initialShow, fireEvent, site } = props;
  const [isOpen, setIsOpen] = useState(false);

  // In theory you could just have isOpen as true and then not need this
  // but there's some bug with Modal that causes events to trigger twice.
  // So picking the more "correct" workaround for now
  useEffect(() => {
    if (initialShow) setIsOpen(true);
  }, [initialShow, setIsOpen]);

  if (!site || !fireEvent) return null;

  return (
    <Modal
      className="mobius-interventions__coverage-diagnosis-modal"
      isOpen={isOpen}
      animation="fade"
      onOpen={() => {
        fireEvent("cd_shown");
      }}
      onClose={() => {
        fireEvent("cd_modal_closed");
        setIsOpen(false);
      }}
    >
      <Text
        variant="h2"
        className="mobius-interventions__coverage-diagnosis-modal-primary-text"
      >
        Unsure what insurance you need?
      </Text>
      <Text
        variant="small"
        className="mobius-interventions__coverage-diagnosis-modal-secondary-text"
      >
        Get a list of tailored covers in seconds!
      </Text>
      <DynamicContent
        site={site as Site}
        vertical={vertical}
        closeModalCallback={() => {
          setIsOpen(false);
        }}
        fireEvent={fireEvent}
      />
      <Button
        data-testid="coverage-diagnosis-modal-close-button"
        className="mobius-interventions__coverage-diagnosis-modal-button"
        variant="ghost"
        size="sm"
        onPress={() => {
          setIsOpen(false);
        }}
      >
        Close
      </Button>
      <div
        data-testid="coverage-diagnosis-modal-image"
        className="mobius-interventions__coverage-diagnosis-modal-image"
      />
    </Modal>
  );
};
